import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

import {AuthService} from '../auth/auth.service';
import {STATUS_CODE} from '@drl/core/api/error-code';
import {UserSessionStoreService as StoreService} from '../store/user-session-store.service';
import {PasswordExpiryEmitter} from '../../password-expiry-popup/services/password-expiry-emitter.service';
import {PasswordExpiry} from '../../password-expiry-popup/services/password-expiry.service';
import {PasswordExpiryEnum} from '../../password-expiry-popup/password-expiry-key.enum';

@Injectable()
export class SessionRecoveryInterceptor implements HttpInterceptor {
  constructor(
    private readonly store: StoreService,
    private readonly sessionService: AuthService,
    private readonly passwordExpiry: PasswordExpiry,
    private readonly passwordExpiryEmitter: PasswordExpiryEmitter,
  ) {}

  private _refreshSubject: Subject<any> = new Subject<any>();

  private _ifTokenExpired() {
    this._refreshSubject.subscribe({
      complete: () => {
        this._refreshSubject = new Subject<any>();
      },
    });

      this.sessionService.refreshToken().subscribe(this._refreshSubject)
    return this._refreshSubject;
  }

  private _checkTokenExpiryErr(error: HttpErrorResponse): boolean {
    return (
      error.status &&
      error.status === STATUS_CODE.UNAUTHORIZED &&
      error.error &&
      error.error.error &&
      (error.error.error.name === 'TokenExpiredError'||error.error.error.message === 'TokenExpiredError')
    );
  }
  private _checkPostTokenExpiryErr(error: HttpErrorResponse): boolean {
    return (
      error.status &&
      error.status === STATUS_CODE.UNAUTHORIZED &&
      error.error &&
      error.error.error &&
      error.error.error.message === 'PasswordExpiryError'
    );
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.endsWith('/logout') || req.url.endsWith('/token-refresh')) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        catchError((error, caught) => {
          if (error instanceof HttpErrorResponse) {
            if(req.url.endsWith('/token-refresh')&&this._checkTokenExpiryErr(error)){
              this.sessionService.logout();
            }else if (this._checkTokenExpiryErr(error)) {
              return this._ifTokenExpired().pipe(
                switchMap(() => next.handle(this.updateHeader(req))),
              );
            } else if (this._checkPostTokenExpiryErr(error)) {
              this.passwordExpiry.expiryType =
                PasswordExpiryEnum.PostPasswordExpired;
              this.passwordExpiryEmitter.passwordExpiryTypeEmitter.next(
                this.passwordExpiry,
              );
              return throwError(error);
            } else {
              return throwError(error);
            }
          }
          return caught;
        }),
      );
    }
  }

  updateHeader(req) {
    const authToken = this.store.getAccessToken();

    if (req.url.includes('api/appointment')) {
      req = req.clone({
        headers: req.headers.set('authorization', `Bearer ${authToken}`),
      });
    } else {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`),
      });
    }
    return req;
  }
}
